<template>
	<!-- Create New Modal -->
	<modal :show.sync="show_modal" modalClasses="medium-sized-modal">
		<h6 slot="header" class="modal-title">Generate Commission Confirmation</h6>
		<b-row>
			<b-col mm="12" class="mx-auto text-center">
				<p>Your case available to generate commission, would you generate commission for your sales now ?</p>
				<p class="text-danger font-weight-500">** Please remember to fill up the sale date for future reference on commission.</p>
			</b-col>
		</b-row>
		<b-row>
			<b-col md="12" class="mx-auto text-center mt-4 pt-2">
				<b-button variant="secondary" type="button" :disabled="is_loading_submit" @click="closeModal()">Generate Later</b-button>
				<b-button variant="primary" type="button" :disabled="is_loading_submit" @click="proceed()">Proceed Now</b-button>
			</b-col>
		</b-row>
	</modal>
</template>
<script>
import caseEventBus from '@/assets/js/EventBus/caseEventBus.js'
import { useCommissionStore } from '@/stores/commissionStore'
import { mapActions, mapState } from 'pinia'

export default {
		data() {
      return {
				is_loading_submit: false,
        show_modal : false,
        commission_content: null
      }
    },
		methods: {
      ...mapActions(useCommissionStore, ['generateCommission']),
      showModal(event){
				if(!_gHlp.isEmpty(event)){
					this.commission_content = event;
					this.show_modal = true;
				}
			},
			proceed(){
				this.generateCommission(this.commission_content);
				this.closeModal();	
			},
			closeModal(){
				this.commission_content = null;
				this.show_modal = false;
				caseEventBus.$emit('refresh-cases')
			}
		},
    mounted() {
    	caseEventBus.$on('show-confirm-commission-modal', this.showModal);
		},
		beforeUnmount(){
			caseEventBus.$off('show-confirm-commission-modal', this.showModal)
		},
}
</script>